import styled, { CSSProperties } from 'styled-components';

import {
  margin,
  MarginProps,
  gap,
  GapProps,
  padding,
  PaddingProps,
  rect,
  RectProps,
} from '../../../components/styles';
import { AppTheme } from '../../../styles/theme';

export const Box = styled.div<
  MarginProps &
    GapProps &
    PaddingProps &
    RectProps & {
      flex?: CSSProperties['flex'];
      overflow?: CSSProperties['overflow'];
      order?: CSSProperties['order'];
      background?: keyof AppTheme['backgroundColors'];
      radii?: keyof AppTheme['radii'];
    }
>`
  position: relative;
  flex: ${({ flex }) => flex};
  overflow: ${({ overflow }) => overflow};
  order: ${({ order }) => order};
  background: ${({ theme, background }) =>
    background && theme.backgroundColors[background]};
  border-radius: ${({ theme, radii }) => radii && theme.radii[radii]};
  ${margin};
  ${padding};
  ${rect};
  ${gap};
`;

Box.displayName = 'Box';
